import defineRule from '../defineRule';
import { email } from '@vee-validate/rules';
defineRule('email', email);
